import React from 'react';
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';

export const UserProfileSkeleton = () => {
  return (
    <div className='user-profile-page user-profile-skeleton'>
      <Card className='profile-header'>
        <div className='profile-hero'>
          <Skeleton shape='circle' className='profile-avatar-skeleton' />
          <div className='profile-hero-text'>
            <div className='profile-info-name'>
              <Skeleton width='200px' height='28px' />
              <Skeleton width='64px' height='24px' />
            </div>
            <Skeleton width='120px' height='20px' />
          </div>
          <div className='profile-actions'>
            <Skeleton width='136px' height='40px' />
            <Skeleton width='120px' height='40px' />
            <Skeleton width='96px' height='40px' />
          </div>
        </div>
        <div className='profile-sections'>
          {[4, 5, 3].map((rows, group) => (
            <div className='profile-field-group' key={group}>
              <Skeleton width='80px' height='16px' className='profile-group-title-skeleton' />
              {Array.from({ length: rows }, (_, row) => (
                <div className='profile-field' key={row}>
                  <Skeleton width='64px' height='12px' />
                  <Skeleton width='160px' height='20px' />
                </div>
              ))}
            </div>
          ))}
        </div>
        <Skeleton className='external-user-signed-documents-skeleton' width='100%' height='40px' />
      </Card>

      <Card title='Actividad'>
        <div className='p-tabview tabview-skeleton'>
          <ul className='p-tabview-nav'>
            <li>
              <Skeleton className='tabview-nav-item-skeleton' width='80px' height='20px' />
            </li>
            <li>
              <Skeleton className='tabview-nav-item-skeleton' width='80px' height='20px' />
            </li>
            <li>
              <Skeleton className='tabview-nav-item-skeleton' width='80px' height='20px' />
            </li>
          </ul>
          <div className='p-tabview-panels'>
            <div className='calendar-container'>
              <div className='calendar-toolbar calendar-toolbar-skeleton'>
                <Skeleton width='200px' height='32px' />
                <div className='calendar-toolbar-buttons'>
                  <Skeleton width='90px' height='24px' />
                  <Skeleton width='90px' height='24px' />
                  <Skeleton width='90px' height='24px' />
                </div>
              </div>
              <Skeleton height='600px' />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
